var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "checkout-info" },
          [
            _vm._l(_vm.items, function(item, itemIndex) {
              return _c(
                "div",
                {
                  key: _vm.uniqueKey(item, itemIndex),
                  staticClass: "item-wrapper"
                },
                [
                  _c("checkout-item", {
                    key: itemIndex,
                    attrs: {
                      isMinified: _vm.isMinified,
                      index: itemIndex,
                      item: item
                    },
                    on: {
                      incrementQuantity: function($event) {
                        return _vm.increment(itemIndex)
                      },
                      decrementQuantity: function($event) {
                        return _vm.decrement(itemIndex)
                      },
                      removeItem: function($event) {
                        return _vm.removeFromCart(itemIndex)
                      },
                      editItem: function($event) {
                        return _vm.editItem(itemIndex)
                      },
                      change: function($event) {
                        return _vm.$emit("change")
                      }
                    }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.totals
              ? _vm._l(_vm.streamLinedTotals, function(value, key) {
                  return _c(
                    "div",
                    { key: key, staticClass: "checkout-total is-size-6" },
                    [
                      key !== "subTotal"
                        ? _c("p", { class: _vm.displayDiscountStyle(value) }, [
                            _c(
                              "span",
                              { staticClass: "has-text-grey is-bold" },
                              [_vm._v(_vm._s(_vm.startCase(key)))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "is-pulled-right has-text-right" },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.centsToDollars(value)))
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                })
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("v-dialog")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2eae75b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eae75b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/CheckoutSummary.vue
// module id = null
// module chunks = 